export interface NotificationsApiResponse {
  items: Notification[];
  nextCursor?: string;
  hasMore: boolean;
}

export interface FetchNotificationsParams {
  cursor?: string;
  read?: string;
  starred?: string;
  taskId?: string;
}

export enum NotificationProduct {
  Budget = "urn:opengov:application:budget",
  Stories = "urn:opengov:application:stories",
  Workflows = "urn:opengov:application:workflows",
  Performance = "urn:opengov:application:performance",
  TaskManager = "urn:opengov:application:taskmanager",
}

export enum NotificationPriority {
  LOW = "low",
  NORMAL = "normal",
  URGENT = "urgent",
}

export interface NotificationContent {
  title: string;
  body: string;
  deepLinkUrl?: string;
}

export interface Notification {
  id: string;
  entityId: string;
  recipientUrn: string;
  taskId?: string;
  subject?: string;
  type: string;
  content: NotificationContent;
  createdAt: string;
  read: boolean;
  readAt?: string;
  starred: boolean;
  priority: NotificationPriority;
  product: string;
}
